import { colors } from "../theme";

type BadgeStatus = "live" | "funded" | "resolved_won" | "resolved_lost" | "cancelled" | "expired";

const config: Record<BadgeStatus, { emoji: string; label: string; color: string }> = {
  live: { emoji: "\u{1F7E2}", label: "LIVE", color: colors.success },
  funded: { emoji: "\u23F3", label: "WAITING", color: colors.amber },
  resolved_won: { emoji: "\u{1F3C6}", label: "WON", color: colors.success },
  resolved_lost: { emoji: "\u{1F921}", label: "LOST", color: colors.danger },
  cancelled: { emoji: "\u{1F6AB}", label: "CANCELLED", color: colors.gray },
  expired: { emoji: "\u23F0", label: "EXPIRED", color: colors.gray },
};

export default function Badge({ status }: { status: BadgeStatus }) {
  const { emoji, label, color } = config[status];

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "3px 8px",
        borderRadius: 6,
        fontSize: 11,
        fontWeight: 700,
        color,
        background: `${color}18`,
      }}
    >
      {emoji} {label}
    </span>
  );
}
